export default import.meta.ROLLDOWN_FILE_URL_SFDiv83Xnc7bN3DcIl_40w